export function getStartOfDay(date: string|Date) {
    return new Date(date).setHours(0, 0, 0, 0);
}

export function getEndOfDay(date: string|Date) {
    return new Date(date).setHours(23, 59, 59, 999);
}
